import { useRouter } from 'next/router'

// Libs
import { useProfileData } from '../../hooks/useProfileData'

// Components
import MemberLives from './MemberLives'
import MemberShop from './MemberShop'
import MemberVips from './MemberVips'

export const TAB_TYPE = {
  LIVES: '0',
  SHOP: '1',
  VIP: '2',
}

const MemberItemList = () => {
  const router = useRouter()
  const { type } = router.query
  const { isMemberProfile } = useProfileData()

  if (isMemberProfile) return null
  switch (type || TAB_TYPE.LIVES) {
    case TAB_TYPE.LIVES:
      return <MemberLives />
    case TAB_TYPE.SHOP:
      return <MemberShop />
    case TAB_TYPE.VIP:
      return <MemberVips />
    default:
      return null
  }
}
export default MemberItemList
